import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { cookieToInitialState, WagmiProvider } from 'wagmi';
import wagmiConfig from '../Config/WagmiConfig';
import { DepositContextProvider } from '../context/depositContext';

const queryClient = new QueryClient();

export function Web3ModalProvider({ children }) {
  const initialState = cookieToInitialState(wagmiConfig);

  return (
    <WagmiProvider config={wagmiConfig} initialState={initialState}>
      <QueryClientProvider client={queryClient}>
        <DepositContextProvider>{children}</DepositContextProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
